import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { HttpStatusCode } from 'axios';
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import HentaiInformation from '@/components/disposable/HentaiInformation.vue';
import { Hentai, HentaiStatus } from '@/model/hentai';
import { createHentai } from '@/repository/hentai';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateHentaiView',
  setup(__props) {

const store = useStore();
const { push } = useRouter();

const isLoading = ref(false);

const hentai = ref<Hentai>({
	coverImageURL: '',
	title: '',
	studio: '',
	episode: {},
	description: '',
	categories: [],
	note: '',
	status: HentaiStatus.OnGoing,
	link: ''
});

async function submit(hentai: Hentai, isRedirect: boolean) {
	try {
		isLoading.value = true;
		const res = await createHentai(hentai);
		if (res.data) {
			isLoading.value = false;
			store.dispatch('alert', { type: 'success', message: `Create new hentai successfully!` });
			if (isRedirect) {
				push(`/hentai/${res.data.hentaiUUID}`);
			}
			return;
		}
		if (res.status === HttpStatusCode.Conflict) {
			store.dispatch('alert', { type: 'warning', message: 'This hentai is exists!' });
		} else {
			throw Error('Something went wrong, please try again!');
		}
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HentaiInformation, {
    hentaiStatuses: [_unref(HentaiStatus).OnGoing, _unref(HentaiStatus).Completed],
    isLoading: isLoading.value,
    hentai: hentai.value,
    onSubmit: submit
  }, null, 8, ["hentaiStatuses", "isLoading", "hentai"]))
}
}

})